{/* Auto-generated icon - do not edit */}
import React from 'react'

interface SquareIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const SquareIcon = React.forwardRef<SVGSVGElement, SquareIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 112 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M3.08791 53.6062C3.41059 46.6096 3.75977 39.6143 4.0405 32.6164C4.27605 26.73 4.41165 20.8404 4.62913 14.9534C4.72787 12.2884 4.91285 9.62331 5.06902 6.96221C5.14647 5.64273 5.62733 4.48247 6.97482 4.13212C9.71758 3.41712 12.4752 2.44802 15.2651 2.29202C25.2951 1.72912 35.3355 1.38202 45.381 1.10382C56.7482 0.790517 68.1247 0.323799 79.4873 0.518799C88.6339 0.679998 97.7701 1.67517 106.901 2.42722C110.306 2.70737 111.854 4.77827 111.726 7.96263C111.349 17.4013 111.095 26.8444 110.705 36.2831C110.124 50.2756 109.483 64.2663 108.848 78.2565C108.606 83.5865 108.249 88.9126 108.056 94.2458C107.856 99.7611 106.422 100.941 101.056 100.999C89.2463 101.122 77.4364 101.495 65.6311 101.822C58.679 102.017 51.7292 102.304 44.7787 102.57C32.977 103.021 21.1759 103.48 9.37503 103.946C8.60061 103.976 7.826 103.966 7.05612 103.935C2.96848 103.774 1.17389 102.071 1.25585 97.9248C1.3946 90.9224 1.69122 83.9219 2.01905 76.9253C2.38238 69.1519 2.85484 61.3841 3.28013 53.6147L3.08791 53.6062ZM100.154 93.8513C101.708 84.3457 104.398 15.9635 103.435 11.171C101.503 11.0014 99.5383 10.781 97.5681 10.664C88.7552 10.1486 79.9384 9.22486 71.1275 9.26776C57.3303 9.33601 43.5363 10.0569 29.7413 10.5171C23.3866 10.729 17.0338 10.9773 10.892 11.2016C10.2757 39.6391 9.66027 68.0534 9.0388 96.7503L100.154 93.8513Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="111" height="104" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

SquareIcon.displayName = 'SquareIcon'
